module.exports = __webpack_public_path__ + "static/real-8a109613177f264be1b43b7158ea3e76.svg";